module.exports = __webpack_public_path__ + "img/stop.99994847.png";